// extracted by mini-css-extract-plugin
export default {"NavSection":"Header_NavSection__BbNFh","AverageUsageWrapper":"Header_AverageUsageWrapper__jmVHK","fullView":"Header_fullView__+KP4+","shimmer":"Header_shimmer__KbX7r"};